module.exports = __webpack_public_path__ + "static/img/18003C_1_R_20201018_fit.3b1d2ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18003C_1_R_20201018_fit.png
// module id = DDg5
// module chunks = 0